<template>
  <div>
    Status servisa eRačuna: <span v-if="seeStatus"> <v-chip class="ma-2" :color="color" text-color="white"> {{ serviceStatus }} </v-chip></span>
    <span v-if="!seeStatus"> <v-chip class="ma-2" :color="color" text-color="white"> {{ serviceStatus }} </v-chip></span>
  </div>
</template>


<script>

import PondiService from '@/services/PondiService'
import merService from '@/services/merService'

export default {
  name: '',
  props: [],
  data: ()=> ({
    serviceStatus: "Nije dostupan!",
    color: "red",
    seeStatus: false
  }),
  async mounted () {
    try {
       let haveStatus = null
       let available = false
       //pondi
       if (this.$store.state.companyActiv.eRacunProvider && this.$store.state.companyActiv.eRacunProvider === 1) {
          const query = {
            pondiKey: this.$store.state.companyActiv.eRacunProviderAPIkey ? this.$store.state.companyActiv.eRacunProviderAPIkey : ''
          }
          const res = await PondiService.testping(query)
          haveStatus = res && res.data ? res.data : null
          if (haveStatus && haveStatus.status && haveStatus.status.status === 'OK') {
            available = true
          }
        }
        // mer
        if (this.$store.state.companyActiv.eRacunProvider && this.$store.state.companyActiv.eRacunProvider === 2) {
          const res = await merService.testping()
          console.log('res mer ', res)
          haveStatus = res && res.data ? res.data : null
          if (haveStatus && haveStatus.vracam && haveStatus.vracam.Status === 'ok') {
            available = true
          }
        }
        if (available) {
          this.color = "green"
          this.serviceStatus = "OK."
          this.seeStatus = true
        }
        if(this.serviceStatus && this.serviceStatus.length > 0) {
          this.haveStatus = true
        }
    } catch (error) {
      // eslint-disable-next-line
      console.log('greska kod monut dokumenta', error)
    }
  },
  methods: {

  },
  computed: {
  },
  watch: {

  },
  components: {

  }

}

</script>